import { Link } from "react-router-dom";
import { useState } from "react";
import { IconButton, Menu, MenuItem } from "@mui/material";
import { MoreVert } from "@mui/icons-material";
import styled from "styled-components/macro";
import { useFlightTranslation } from "utils/customHooks/useFlightTranslation";
import { LinkIcon } from "svgs";
import { blueCheckbox } from "reports/constants/colors";

/** MoreVert IconButton + Menu containing a link to &view=tl&quickView=lastWeek */
export function GroupTileMoreMenu({
  summaryGroup,
  workScheduleId,
  customerKey,
}: {
  summaryGroup: string;
  workScheduleId: string;
  customerKey: string;
}) {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  return (
    <>
      <StyledIconButton
        className="group-tile-more-menu"
        size="small"
        onClick={e => setAnchorEl(e.currentTarget)}
      >
        <MoreVert />
      </StyledIconButton>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={() => setAnchorEl(null)}
        disableScrollLock={true}
      >
        <LastWeekMenuItem {...{ customerKey, summaryGroup, workScheduleId }} />
      </Menu>
    </>
  );
}
const StyledIconButton = styled(IconButton)`
  position: absolute;
  bottom: 0;
  right: 0;
`;
const StyledLink = styled(Link)`
  display: flex;
  align-items: center;
  gap: 0.5em;
`;

function LastWeekMenuItem({
  customerKey,
  summaryGroup,
  workScheduleId,
}: {
  customerKey: string;
  summaryGroup: string;
  workScheduleId: string;
}) {
  const { translate } = useFlightTranslation();
  return (
    <MenuItem>
      <StyledLink
        to={`/${customerKey}/dashboard/${summaryGroup}?workSchedule=${workScheduleId}&view=tl&quickView=lastWeek`}
      >
        <LinkIcon pathprops={{ fill: blueCheckbox }} />
        {translate("Last_Week's_Timeline")}
      </StyledLink>
    </MenuItem>
  );
}
